var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinistries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 52,
    style: {
      fill: "#FFFFFF"
    },
    width: 504,
    height: 408
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M504,56v400H8V56H504 M512,48H0v416h512V48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M400.168,124.56c12.4,0,22.456,10.056,22.456,22.456s-10.056,22.456-22.456,22.456 s-22.456-10.056-22.456-22.456l0,0C377.728,134.624,387.776,124.576,400.168,124.56"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M424.992,184.976l-24.8,18.712l-24.8-18.712c-17.712,5.376-29.92,21.592-30.168,40.104H455.2 C454.944,206.56,442.72,190.336,424.992,184.976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M255.832,124.56c12.4,0,22.456,10.056,22.456,22.456s-10.056,22.456-22.456,22.456 s-22.456-10.056-22.456-22.456l0,0C233.392,134.624,243.44,124.576,255.832,124.56"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M280.656,184.976l-24.8,18.712l-24.8-18.712c-17.752,5.344-29.992,21.568-30.256,40.104h110.032 C310.576,206.568,298.376,190.344,280.656,184.976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M111.496,124.56c12.4,0,22.456,10.056,22.456,22.456s-10.056,22.456-22.456,22.456 S89.04,159.416,89.04,147.016l0,0C89.056,134.624,99.104,124.576,111.496,124.56"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M136.328,184.976l-24.8,18.712l-24.8-18.712c-17.712,5.376-29.92,21.592-30.168,40.104h109.936 C166.248,206.568,154.04,190.352,136.328,184.976z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.832,
    y: 351.44,
    style: {
      fill: "#000000"
    },
    width: 112,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.832,
    y: 383.44,
    style: {
      fill: "#000000"
    },
    width: 80,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.832,
    y: 351.44,
    style: {
      fill: "#000000"
    },
    width: 112,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.832,
    y: 383.44,
    style: {
      fill: "#000000"
    },
    width: 80,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.832,
    y: 351.44,
    style: {
      fill: "#000000"
    },
    width: 112,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.832,
    y: 383.44,
    style: {
      fill: "#000000"
    },
    width: 80,
    height: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000"
    },
    cx: 111.832,
    cy: 291.44,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000"
    },
    cx: 255.832,
    cy: 291.44,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000"
    },
    cx: 399.832,
    cy: 291.44,
    r: 16
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinistries);
export default __webpack_public_path__ + "static/media/ministries.414f6ebbf60b61748aac2cfc16976844.svg";
export { ForwardRef as ReactComponent };